import { Routes } from '@angular/router';
import { AuthGuard } from '../auth/auth.guard';
import {
  DASHBOARD_ENABLED,
  HOME_ROUTE,
} from '../common/constants/dashboard-visibility';

/**
 * Split out from the object below so both branches are testable regardless of the flag's
 * current value.
 */
export function dashboardRouteConfig(enabled: boolean): Routes {
  // Hidden for now: anyone hitting /dashboard (or anything under it) is bounced
  // to the home screen instead, and the lazy chunk is never requested.
  if (!enabled) {
    return [{ path: 'dashboard', redirectTo: HOME_ROUTE }];
  }

  return [
    {
      path: 'dashboard',
      canActivate: [AuthGuard],
      // Lazy-loaded — see DashboardModule for why.
      loadChildren: () =>
        import('../dashboard/dashboard.module').then((m) => m.DashboardModule),
    },
  ];
}

export const dashboardRoutes = {
  prefix: 'dashboard',
  routes: function () {
    return dashboardRouteConfig(DASHBOARD_ENABLED);
  },
};
